module.exports = __webpack_public_path__ + "img/Layer-9.b197dd7e.webp";